import axios from "axios";
import store from '../../store';
import Cookies from 'universal-cookie';
import sentry from "../sentry";
import {setUnderConstruction} from "../../store/app-slice";
import {setAlert} from "../../store/alerts-slice";
const cookies = new Cookies();

const baseURL = process.env.REACT_APP_API;

const api = {
    async get(url, params = null) {
        let fullUrl = this.createFullUrl(url)
        // let access_token = store.getState().access_token ? store.getState().access_token : localStorage.getItem('access_token');
        let access_token = store.getState().access_token ? store.getState().access_token : cookies.get('access_token');
        let config = {
            headers: { Authorization: `Bearer ${access_token}` }
        };
        // console.log('>>> get:',  baseURL + url)

        if(params !== null) {
            fullUrl += `?${Object.keys(params).map(key => `${key}=${params[ key ]}`).join('&')}`
        }

        try {
            let res = await axios.get(fullUrl, config)
            // console.log('aa', res)
            if (res.status !== 200) {
                return this.requestErrorHandler('GET', url, res)
            }

            res.success = true;
            return res;
        } catch (e) {
            // console.log('aaa', e.response)
            return this.requestErrorHandler('[E]GET', url, e.response)
        }
    },

    async post(url, payload) {
        let fullUrl = this.createFullUrl(url)

        // let access_token = store.getState().access_token ? store.getState().access_token : localStorage.getItem('access_token');
        let access_token = store.getState().access_token ? store.getState().access_token : cookies.get('access_token');

        // console.log('>>>', payload.access_token)
        let config = {
            headers: { Authorization: `Bearer ${access_token}` }
        };
        // console.log('>>> get:',  baseURL + url)

        try {
            let res = await axios.post(fullUrl, payload, config)
            // console.log('aa', res)
            if (res.status !== 200) {
                return this.requestErrorHandler('POST', url, res)
            }

            res.success = true;
            return res;
        } catch (e) {
            return this.requestErrorHandler('[E]POST', url, e.response)
        }
    },

    async delete(url) {
        let fullUrl = this.createFullUrl(url)

        // let access_token = store.getState().access_token ? store.getState().access_token : localStorage.getItem('access_token');
        let access_token = store.getState().access_token ? store.getState().access_token : cookies.get('access_token');

        // console.log('>>>', payload.access_token)
        let config = {
            headers: { Authorization: `Bearer ${access_token}` }
        };
        // console.log('>>> get:',  baseURL + url)

        try {
            let res = await axios.delete(fullUrl, config)
            // console.log('aa', res)
            if (res.status !== 200) {
                return this.requestErrorHandler('DELETE', url, res)
            }

            res.success = true;
            return res;
        } catch (e) {
            return this.requestErrorHandler('[E]DELETE', url, e.response)
        }
    },

    async patch(url, payload) {
        let fullUrl = this.createFullUrl(url)

        // let access_token = store.getState().access_token ? store.getState().access_token : localStorage.getItem('access_token');
        let access_token = store.getState().access_token ? store.getState().access_token : cookies.get('access_token');

        // console.log('>>>', payload.access_token)
        let config = {
            headers: { Authorization: `Bearer ${access_token}` }
        };

        try {
            let res = await axios.patch(fullUrl, payload, config)
            // console.log('aa', res)
            if (res.status !== 200) {
                return this.requestErrorHandler('PATCH', url, res)
            }

            res.success = true;
            return res;
        } catch (e) {
            return this.requestErrorHandler('[E]PATCH', url, e.response)
        }
    },

    //----------------------------------------------------------------------------------------

    createFullUrl(url) {
        url = url.replace(/^\//, '');
        // console.log(baseURL + url)
        return baseURL + url;
    },

    assignParams(url, params = {}) {
        let fullUrl = url;
        if(params) {
            // Apply params to fullUrl
            Object.keys(params).forEach((key, i) => {
                const val = params[key] ? params[key] : '';
                fullUrl += `${i === 0 ? '?' : '&'}${key}=${val}`;
            });
        }

        return fullUrl;
    },

    async requestErrorHandler(method, url, res) {
        let sentryCapture = true;

        console.error(`req-err [1]: ${method}(${url}), ${res ? res.status : 'no res'}`);
        console.error('req-err [2]:', res);
        // console.log('>>>3', res.data.data.errors[0].error);

        // Checking if service is down:
        if (res === undefined && url !== 'api-status') {
            // console.error('no response, service might be down.');
            try {
                let isApiAlive = await api.get('api-status');
                if (!isApiAlive || !isApiAlive.success) {
                    store.dispatch(setUnderConstruction(true));
                }
            } catch (e) {
                console.error('Service is down.');
                store.dispatch(setUnderConstruction(true));
            }
        }

        //Checking if no permissions:
        if (res && res.status === 418) {
            store.dispatch(setAlert({type: 'warning', header: 'No permissions', body: `Contact your supervisor for help`}));
            sentryCapture = false;
        }

        if (sentryCapture && res instanceof Error) {
            sentry.capture(res)
        }


        let errResponseObject =  {
            ...res,
            success: false,
            errorText: this.getErrorText(res),

        }
        // console.log('errResponseObject', errResponseObject)
        return errResponseObject;
    },

    getErrorText(res) {
        // console.log('getErrorText: ', res)

        if (res && res.data && res.data.data && res.data.data.errors && res.data.data.errors[0] && res.data.data.errors[0].error) {
            return res.data.data.errors[0].error;
        }

        if (res && res.data && res.data && res.data.errors && res.data.errors[0] && res.data.errors[0].error) {
            return res.data.errors[0].error;
        }

        return 'An error occurred';
    }

}

export default api;
